import HtmlDiff from 'node-htmldiff';

type Options = {
  hideUnchanged?: boolean;
  blockSelector?: string;
};

function stripStylesAndClasses(html: string): string {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');

  // Remove all style attributes and class attributes
  doc.body.querySelectorAll('*').forEach((el) => {
    el.removeAttribute('style');
    el.removeAttribute('class');
  });

  return doc.body.innerHTML;
}

const DEFAULT_BLOCK_SELECTOR = 'p,h1,h2,h3,h4,h5,h6,li,td,th,blockquote,hr';

export function diffHtml(
  oldHtml: string,
  newHtml: string,
  {hideUnchanged = false, blockSelector = DEFAULT_BLOCK_SELECTOR}: Options = {}
) {
  const parser = new DOMParser();

  // Strip styles and classes before diffing to avoid false positives
  const normalizedOldHtml = stripStylesAndClasses(oldHtml);
  const normalizedNewHtml = stripStylesAndClasses(newHtml);

  // Perform diff on the normalized HTML
  const diffedHtml = HtmlDiff(normalizedOldHtml, normalizedNewHtml);

  // Parse the diffed result
  const doc = parser.parseFromString(diffedHtml, 'text/html');

  if (hideUnchanged) {
    // Remove blocks that have no changes
    doc.body.querySelectorAll(blockSelector).forEach((el) => {
      if (!el.querySelector('ins, del')) {
        el.remove();
      }
    });

    // Remove empty container elements (tables, lists, wrappers, etc.) after removing unchanged blocks.
    // Run multiple times so nested structures collapse (e.g. tbody → table → div).
    let hasRemovals = true;
    while (hasRemovals) {
      hasRemovals = false;
      doc.body
        .querySelectorAll('div, section, table, ul, ol, tbody, thead, tfoot, tr, colgroup, caption')
        .forEach((el) => {
          const hasContent = el.textContent?.trim() || el.querySelector('ins, del');
          if (!hasContent) {
            el.remove();
            hasRemovals = true;
          }
        });
    }
  }

  return {
    beforeHtml: oldHtml,
    afterHtml: doc.body.innerHTML,
  };
}
